import { createOptions } from 'apps/web/types/option';

export const LIST_OF_ATTITUDES = createOptions([
  'Self-esteem',
  'Self-confidence',
  'Wellness',
  'Respect',
  'Honesty',
  'Personal discipline',
  'Perseverance',
  'Sincerity',
  'Patience',
  'Critical thinking',
  'Open-mindedness',
  'Interest',
  'Courteous',
  'Obedience',
  'Hope',
  'Charity',
  'Fortitude',
  'Resiliency',
  'Positive vision',
  'Acceptance',
  'Determined',
  'Independent',
  'Gratitude',
  'Tolerant',
  'Cautious',
  'Decisive',
  'Self-control',
  'Calmness',
  'Responsibility',
  'Accountability',
  'Industriousness',
  'Industry',
  'Cooperation',
  'Optimism',
  'Satisfaction',
  'Persistent',
  'Cheerful',
  'Reliable',
  'Gentle',
  "Appreciation of one's culture",
  'Globalism',
  'Compassion',
  'Work ethics',
  'Creativity',
  'Entrepreneurial spirit',
  'Financial literacy',
  'Global solidarity',
  'Making a stand for the good',
  'Voluntariness of human act',
  "Appreciation of one's rights",
  'Inclusiveness',
  'Thoughtful',
  'Seriousness',
  'Generous',
  'Happiness',
  'Modest',
  'Authority',
  'Hardworking',
  'Realistic',
  'Flexible',
  'Considerate',
  'Sympathetic',
  'Frankness',
  'Dependability',
  'Gratefulness',
]);

export const GOD_CENTERED_VALUES = createOptions([
  'Love of God',
  'Faith',
  'Trusting',
  'Spirituality',
  'Inner peace',
  'Love of truth',
  'Kindness',
  'Humble',
]);

export const PEOPLE_CENTERED_VALUES = createOptions([
  'Concern for others',
  'Respect for human rights',
  'Gender equality',
  'Family solidarity',
  'Generosity',
  'Helping',
  'Oneness',
  'Knowing and accepting oneself',
  'Work and play',
  'Health',
  'Punctuality',
  'Interpersonal relationship',
  'Loyalty',
  'Commitment to the family',
]);

export const ENVIRONMENT_CENTERED_VALUES = createOptions([
  'Care of the environment',
  'Disaster risk management',
  'Protection of the environment',
  'Responsible consumerism',
  'Cleanliness',
  'Orderliness',
  'Saving the ecosystem',
  'Environmental sustainability',
]);

export const NATION_CENTERED_VALUES = createOptions([
  'Peace and order',
  'Heroism and appreciation of heroes',
  'National unity',
  'Civic consciousness',
  'Social responsibility',
  'Harmony',
  'Patriotism',
  'Productivity',
  'Love for family and country',
]);
